module.exports = __webpack_public_path__ + "img/nav-03.c81ad95c.jpg";